document.addEventListener("DOMContentLoaded", function () {
  let linkss = document.links;
  for (let i = 0, linksLength = linkss.length; i < linksLength; i++) {
    if (linkss[i].hostname !== window.location.hostname) {
      linkss[i].target = "_blank";
      linkss[i].rel = "noreferrer noopener";
    }
  }

  const marqueeContainers = document.querySelectorAll(".marquee-container");

  marqueeContainers.forEach((container) => {
    const grid = container.querySelector(".marquee-grid");

    const gridWidth = grid.offsetWidth;
    const screenWidth = window.innerWidth;
    const gridPercentage = (gridWidth / screenWidth) * 100;

    if (gridPercentage < 50) {
      // Marquee ist kleiner als 25%, klone das Grid zweimal
      cloneGrid(grid, 2);
    } else if (gridPercentage > 50) {
      // Marquee ist kleiner als 50%, klone das Grid einmal
      cloneGrid(grid, 1);
    }
    if (container.classList.contains("double")) {
      cloneGrid(grid, 1);
    }
  });

  function cloneGrid(grid, times) {
    for (let i = 0; i < times; i++) {
      const clone = grid.cloneNode(true);
      grid.parentNode.appendChild(clone);
    }
  }

  const copyButtons = document.querySelectorAll(".copybutton");
  if (copyButtons.length > 0) {
    copyButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        navigator.clipboard
          .writeText(window.location.href)
          .then(function () {})
          .catch(function (error) {});
        if (button.querySelector(".success-message")) {
          button.querySelector(".success-message").classList.add("show");
          setTimeout(function () {
            button.querySelector(".success-message").classList.remove("show");
          }, 2000);
        }
      });
    });
  }

  const submenuButtons = document.querySelectorAll("button.has-submenu");

  submenuButtons.forEach((button) => {
    button.addEventListener("click", function () {
      if (this.classList.contains("active")) {
        this.classList.remove("active");
        this.setAttribute("aria-expanded", "false");
        return;
      }
      if (!this.classList.contains("has-submenu-mobile")) {
        submenuButtons.forEach((btn) => {
          btn.classList.remove("active");
          btn.setAttribute("aria-expanded", "false");
        });
      }
      this.classList.add("active");
      this.setAttribute("aria-expanded", "true");
    });
  });

  document.addEventListener("click", function (event) {
    const header = document.querySelector(".header");
    if (!header.contains(event.target)) {
      submenuButtons.forEach((button) => {
        button.classList.remove("active");
      });
    }
  });

  // Hole das Button-Element mit der ID
  const toggleButton = document.getElementById("toggleButton");

  // Füge einen Klick-Listener hinzu
  toggleButton.addEventListener("click", function () {
    // Toggle die Klasse "open" auf dem Button-Element
    if (toggleButton.classList.contains("open")) {
      // Entferne die Klasse 'open'
      toggleButton.classList.remove("open");
      toggleButton.setAttribute("aria-expanded", "false");
    } else {
      // Füge die Klasse 'open' hinzu
      toggleButton.classList.add("open");
      toggleButton.setAttribute("aria-expanded", "true");
    }
    var bodyelement = document.querySelector("body");
    if (bodyelement.classList.contains("fix-body")) {
      // bodyelement.classList.remove("overflow-hidden");
      bodyelement.classList.remove("fix-body");
    } else {
      // bodyelement.classList.add("overflow-hidden");
      bodyelement.classList.add("fix-body");
    }
  });

  //Modals
  let modals = document.querySelectorAll(".modal");
  if (modals.length > 0) {
  }

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" || event.key === "Esc") {
      // Entferne die Klasse 'open' vom Popup-Wrapper
      if (modals.length > 0) {
        // Entferne die Klasse 'open' von jedem gefundenen Element
        modals.forEach(function (modal) {
          modal.classList.remove("open");
        });
      }
    }
  });

  //Accordion
  const accordionButtons = document.querySelectorAll(".accordion-button");

  accordionButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const target = document.getElementById(
        button.getAttribute("aria-controls")
      );
      const isOpen = target.classList.contains("show");

      if (isOpen) {
        // Collapse the accordion
        target.style.height = `${target.scrollHeight}px`;
        // Force reflow for the transition to kick in
        target.offsetHeight;
        target.style.height = "0px";
        button.setAttribute("aria-expanded", "false");

        target.addEventListener("transitionend", function onTransitionEnd() {
          target.classList.remove("show");
          target.style.height = "";
          target.removeEventListener("transitionend", onTransitionEnd);
        });
      } else {
        // Expand the accordion
        target.style.height = "0px";
        target.classList.add("show");
        button.setAttribute("aria-expanded", "true");
        target.offsetHeight;
        target.style.height = `${target.scrollHeight}px`;

        target.addEventListener("transitionend", function onTransitionEnd() {
          target.style.height = "auto";
          target.removeEventListener("transitionend", onTransitionEnd);
        });
      }
    });
  });

  document.querySelectorAll(".home-hero-slider").forEach((sliderElement) => {
    const autoplayEnabled = sliderElement.dataset.autoplay === "true";
    const delay = Number.parseInt(sliderElement.dataset.delay, 10) || 6000;

    new Swiper(sliderElement, {
      slidesPerView: 1,
      autoHeight: true,
      loop: sliderElement.querySelectorAll(".swiper-slide").length > 1,
      speed: 650,
      grabCursor: true,
      keyboard: { enabled: true },
      autoplay: autoplayEnabled
        ? { delay, disableOnInteraction: false, pauseOnMouseEnter: true }
        : false,
      navigation: {
        prevEl: sliderElement.querySelector(".espl-hero__arrow--prev"),
        nextEl: sliderElement.querySelector(".espl-hero__arrow--next"),
      },
      pagination: {
        el: sliderElement.querySelector(".swiper-pagination"),
        clickable: true,
        type: "bullets",
      },
    });
  });
  let productSwiper = document.querySelector(".product-swiper");
  if (productSwiper) {
    productSwiper = new Swiper(".product-swiper", {
      slidesPerView: 1,
      breakpointsBase: "container",
      breakpoints: {
        900: {
          slidesPerView: 2.5,
        },

        1200: {
          slidesPerView: 3,
        },
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        type: "bullets",
      },
    });
  }
  let productGallerySwiper = document.querySelector(".product-gallery-slider");
  if (productGallerySwiper) {
    productGallerySwiper = new Swiper(".product-gallery-slider", {
      slidesPerView: 1,
      breakpointsBase: "container",
      pagination: {
        el: ".product-swiper-pagination",
        clickable: true,
        type: "bullets",
      },
    });
  }
  let aromenSwiper = document.querySelector(".aromen-swiper");
  if (aromenSwiper) {
    aromenSwiper = new Swiper(".aromen-swiper", {
      slidesPerView: 1,
      spaceBetween: 120,
      watchOverflow: true,
      breakpointsBase: "container",
      breakpoints: {
        900: {
          slidesPerView: 2,
        },

        1200: {
          slidesPerView: 3,
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
  let testimonialsSwiper = document.querySelector(".testimonials-swiper");
  if (testimonialsSwiper) {
    let slideCount =
      testimonialsSwiper.querySelectorAll(".swiper-slide").length;

    // Standard-Breakpoints
    let breakpoints = {
      900: { slidesPerView: 2 },
      1200: { slidesPerView: 3 },
    };

    // Bedingungen je nach Anzahl der Slides
    if (slideCount === 1) {
      breakpoints = {
        900: { slidesPerView: 1 },
        1200: { slidesPerView: 1 },
      };
    } else if (slideCount === 2) {
      breakpoints = {
        900: { slidesPerView: 2 },
        1200: { slidesPerView: 2 },
      };
    }
    testimonialsSwiper = new Swiper(".testimonials-swiper", {
      slidesPerView: 1,
      watchOverflow: true,
      breakpointsBase: "container",
      breakpoints: breakpoints,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        type: "bullets",
      },
    });
  }
  const multistepForm = document.querySelector(".js-multistep-form");
  if (multistepForm) {
    let formStepSwiper, formBodySwiper;
    const stepSwiperEl = multistepForm.querySelector(".form-step-swiper");
    const bodySwiperEl = multistepForm.querySelector(".form-body-swiper");
    const btnPrev = multistepForm.querySelector(".form-prev-button");
    const btnNext = multistepForm.querySelector(".form-next-button");
    const btnSubmit = multistepForm.querySelector(".form-submit-button");

    if (stepSwiperEl) {
      formStepSwiper = new Swiper(stepSwiperEl, {
        slidesPerView: "auto",
        spaceBetween: 40,
      });
    }
    if (bodySwiperEl) {
      formBodySwiper = new Swiper(bodySwiperEl, {
        slidesPerView: 1,
        spaceBetween: 20,
        allowTouchMove: false,
        autoHeight: true,
      });
    }

    const getStepSlides = () => stepSwiperEl.querySelectorAll(".swiper-slide");
    const getBodySlides = () => bodySwiperEl.querySelectorAll(".swiper-slide");

    function getCurrentStepIndex() {
      const slides = getStepSlides();
      const current = stepSwiperEl.querySelector(".swiper-slide.current");
      return Array.prototype.indexOf.call(slides, current);
    }

    function goToStep(index) {
      const stepSlides = getStepSlides();
      const bodySlides = getBodySlides();
      const maxIndex = Math.min(stepSlides.length, bodySlides.length) - 1;
      const i = Math.max(0, Math.min(index, maxIndex));
      stepSlides.forEach((s) => s.classList.remove("current"));
      stepSlides[i].classList.remove("validated");
      stepSlides[i].classList.add("current");
      formStepSwiper?.slideTo(i);
      formBodySwiper?.slideTo(i);
      if (btnPrev) btnPrev.disabled = i === 0;
      if (btnNext) btnNext.disabled = i === maxIndex;
      if (btnSubmit) btnSubmit.disabled = i !== maxIndex;
    }

    function validateCurrentStep() {
      const currentIndex = getCurrentStepIndex();
      const bodySlide = getBodySlides()[currentIndex];
      if (!bodySlide) return true;
      const controls = bodySlide.querySelectorAll("input, select, textarea");
      let firstInvalid = null;
      for (const el of controls) {
        if (typeof el.checkValidity === "function" && !el.checkValidity()) {
          firstInvalid = firstInvalid || el;
        }
      }
      if (firstInvalid) {
        firstInvalid.reportValidity?.();
        firstInvalid.focus();
        return false;
      }
      return true;
    }

    btnNext?.addEventListener("click", () => {
      const currentIndex = getCurrentStepIndex();
      if (!validateCurrentStep()) return;
      getStepSlides()[currentIndex]?.classList.add("validated");
      goToStep(currentIndex + 1);
    });

    btnPrev?.addEventListener("click", () => {
      const currentIndex = getCurrentStepIndex();
      goToStep(currentIndex - 1);
    });

    stepSwiperEl?.addEventListener("click", (e) => {
      const slide = e.target.closest(".swiper-slide");
      if (!slide) return;
      const targetIndex = Array.prototype.indexOf.call(getStepSlides(), slide);
      const currentIndex = getCurrentStepIndex();
      if (targetIndex === currentIndex) return;
      if (targetIndex < currentIndex) {
        goToStep(targetIndex);
        return;
      }
      if (!validateCurrentStep()) return;
      getStepSlides()[currentIndex]?.classList.add("validated");
      goToStep(currentIndex + 1);
    });

    multistepForm.addEventListener(
      "input",
      () => {
        const idx = getCurrentStepIndex();
        const step = getStepSlides()[idx];
        step?.classList.remove("validated");
      },
      { capture: true }
    );

    goToStep(getCurrentStepIndex() >= 0 ? getCurrentStepIndex() : 0);
  }
});

document.addEventListener("DOMContentLoaded", (event) => {
  // if (!window.lenis) {
  //   window.lenis = new Lenis();
  // }
  if (document.querySelector(".back-to-top")) {
    document.querySelector(".back-to-top").addEventListener("click", () => {
      lenis.scrollTo(0);
    });
  }

  // window.lenis.on("scroll", ScrollTrigger.update);

  // gsap.ticker.add((time) => {
  //   window.lenis.raf(time * 1000);
  // });

  gsap.ticker.lagSmoothing(0);

  gsap.registerPlugin(ScrollTrigger);

  // create
  let mm = gsap.matchMedia();

  mm.add("(min-width: 768.1px)", () => {
    let parallax_images = document.querySelectorAll(".img-wrapper-animation");
    if (parallax_images.length > 0) {
      parallax_images.forEach((image) => {
        let realImage = image.querySelector("img");
        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: image,
            scrub: 2,
          },
          defaults: {
            ease: "none",
          },
        });
        tl.fromTo(
          realImage,
          {
            yPercent: 10,
          },
          {
            yPercent: -10,
          }
        );
      });
    }

    //Marquee
  });

  let marqueeContainer = document.querySelectorAll(
    ".marquee-container.every-time"
  );
  if (marqueeContainer.length > 0) {
    marqueeContainer.forEach((el) => {
      let marquee = el.querySelectorAll(".marquee-grid");
      let direction = el.classList.contains("reverse") ? 100 : -100;
      gsap.to(marquee, {
        xPercent: direction,
        ease: "none",
        duration: 20,
        repeat: -1,
      });
    });
  }

  let scaleUpElements = gsap.utils.toArray(".scale-up-scroll");

  if (scaleUpElements.length > 0) {
    gsap.set(scaleUpElements, { scale: 0 });

    scaleUpElements.forEach((element) => {
      gsap.to(element, {
        scale: 1,
        duration: 1,
        ease: "power4.out",
        scrollTrigger: {
          trigger: element,
          start: "top 80%",
          toggleActions: "play none none none",
        },
      });
    });
  }
});
